//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import { mapState } from "vuex";
import countryBlocker from "~/middleware/country";

export default {
    data() {
        return {
            region: "au",
        };
    },
    computed: {
        ...mapState({
            page: (state) => state.pages.page,
        }),
    },
    async created() {
        if ((process.browser || process.client) && process.env && !!process.env.MAINTENANCE) {
            window.location.assign("https://contact.burstsms.com/upgrade?url=" + window.location.href);
        }

        if (process.browser || process.client) {
            await countryBlocker(this.$nuxt.context);

            this.country = "Australia";
            this.region = "au";

            if (this.page.region === "United States") {
                this.country = "United States";
                this.region = "us";
            }

            if (this.page.region === "New Zealand") {
                this.country = "New Zealand";
                this.region = "nz";
            }

            $(function () {
                $("#terms-modal").modal({
                    show: false,
                });

                $("body").on("click", '[href="#offer"]', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(".modal.show").modal("hide");
                    $("#form-request")[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
                });
                $("body").on("click", '[href="#terms"]', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(".modal.show").modal("hide");
                    $("#terms-modal").modal("show");
                });

                if (window.location.hash === "#offer") {
                    $(".modal.show").modal("hide");
                    $("#form-request")[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
                }
                if (window.location.hash === "#terms") {
                    $("#terms-modal").modal("show");
                }
            });
        }
    },
};
